export default __webpack_public_path__ + "static/media/snowicon.6b4093c2.png";